'use client'
import Link from 'next/link'
import React, { useEffect, useState, useMemo } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import styles from './Nav.module.css'
import CustomNav from './CustomNav'
import BrandNav from './BrandNav'
import CustomPictureNav from './CustomPictureNav'

export default function Nav({
  cusomNav,
  headerStyle = {},
  brand = [],
  categoryItems,
}) {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  // 顏色安全預設
  const {
    HeaderFontColor = 'black',
    HeaderFontFocusColor = 'red',
    HeaderBGColor = 'transparent',
  } = headerStyle || {}

  // const [categoryItems, setCategoryItems] = useState([])
  const [blogCategory, setBlogCategory] = useState([])

  // 商品
  const [hoverPath, setHoverPath] = useState([])
  const [menuVisible, setMenuVisible] = useState(false)

  // 參數/active 判斷
  const [activeNavByClick, setActiveNavByClick] = useState(null) // 記錄點擊的選單
  const [activeCustomMenuId, setActiveCustomMenuId] = useState(null)

  const activeCategoryId = searchParams.get('categoryid') ?? ''
  const activeBrandId = searchParams.get('brandid') ?? ''

  const isProductActive = activeNavByClick === 'Product'

  const isBrandActive = activeNavByClick === 'Brand'

  const isCustomActive = activeNavByClick === 'Custom'

  useEffect(() => {
    if (pathname === '/') {
      setActiveNavByClick(null)
    }
  }, [pathname])

  useEffect(() => {
    // const fetchCategories = async () => {
    //   try {
    //     const res = await fetch(
    //       `/api/product/get_category?StoreNumber=${process.env.NEXT_PUBLIC_STORE_NUMBER}`
    //     )
    //     if (!res.ok)
    //       throw new Error(`API request failed with status ${res.status}`)
    //     const json = await res.json()
    //     if (json.Data) setCategoryItems(json.Data)
    //   } catch (error) {
    //     console.error('Error fetching content:', error)
    //   }
    // }

    const fetchBlogCategory = async () => {
      try {
        const res = await fetch(
          `/api/blogs/get_ArticleCategory?StoreNumber=${process.env.NEXT_PUBLIC_STORE_NUMBER}`
        )
        const data = await res.json()
        if (data.Data) {
          setBlogCategory(
            data.Data.map((item) => ({
              ...item,
              href: `/blogs-list/${item.ArticleCategorySlug}`,
            }))
          )
        }
      } catch (error) {
        console.error('Error fetching content:', error)
      }
    }

    // fetchCategories()
    fetchBlogCategory()
  }, [])

  // 商品選單
  const flatList = useMemo(() => {
    if (!Array.isArray(categoryItems) || categoryItems.length === 0) return []
    const res = []
    const traverse = (arr) => {
      arr.forEach((item) => {
        res.push(item)
        if (item.Children?.length) traverse(item.Children)
      })
    }
    traverse(categoryItems)
    return res
  }, [categoryItems])

  const getChildren = (parentId) =>
    flatList.filter(
      (x) => (x.ParentID ?? x.ParentCategoryID ?? null) === parentId
    )

  const menuLayers = []
  let currentParentId = null
  for (let i = 0; i <= hoverPath.length; i++) {
    const items = getChildren(currentParentId)
    if (items.length > 0) menuLayers.push(items)
    currentParentId = hoverPath[i]
  }

  const handleHover = (levelIndex, cat) => {
    const newPath = hoverPath.slice(0, levelIndex)
    newPath[levelIndex] = cat.CategoryID
    setHoverPath(newPath)
  }

  const handleMouseLeave = () => {
    setHoverPath([])
    setMenuVisible(false)
  }

  if (headerStyle?.CustomMenuStyle === 'picture') {
    return (
      <>
        {headerStyle?.GoodsCategoryEnable && (
          <li
            className="navigation__item"
            onMouseLeave={handleMouseLeave}
            onMouseEnter={() => setMenuVisible(true)}
            style={{
              position: 'relative',
            }}
          >
            <Link
              href="/product-list"
              className={`navigation__link`}
              style={{
                color: isProductActive ? HeaderFontFocusColor : HeaderFontColor,
              }}
              onClick={(e) => {
                e.stopPropagation()
                setActiveNavByClick('Product')
                setActiveCustomMenuId(null)
              }}
            >
              商品
            </Link>

            {menuVisible && (
              <div className={styles.menuContainer}>
                {menuLayers.map((items, levelIndex) => (
                  <ul key={levelIndex} className={styles.menuList}>
                    {items.map((cat) => {
                      const hasChildren = getChildren(cat.CategoryID).length > 0
                      return (
                        <li
                          key={cat.CategoryID}
                          className={`${styles.menuItem}`}
                          onMouseEnter={() => handleHover(levelIndex, cat)}
                        >
                          <span className={styles.menuLink}>
                            {hasChildren ? (
                              // 🟢 有子層 → 不能點，只是 hover 展開
                              <Link
                                href={`/product-list?categoryid=${cat.CategoryID}`}
                                className={styles.menuLink}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  setMenuVisible(false)
                                  setActiveNavByClick('Product')
                                  setActiveCustomMenuId(null)
                                }}
                              >
                                {cat.CategoryName}
                                <span className={styles.chevron}>›</span>
                              </Link>
                            ) : (
                              // 🔵 最後一層 → 可以點擊跳轉
                              <Link
                                href={`/product-list?categoryid=${cat.CategoryID}`}
                                className={styles.menuLink}
                                onClick={(e) => {
                                  e.stopPropagation() // 避免觸發 hover 展開
                                  setMenuVisible(false) // ✅ 點擊後關閉選單（如果你有這需求）
                                  setActiveNavByClick('Product')
                                  setActiveCustomMenuId(null)
                                }}
                              >
                                {cat.CategoryName}
                              </Link>
                            )}
                          </span>
                        </li>
                      )
                    })}
                  </ul>
                ))}
              </div>
            )}
          </li>
        )}

        {/* 品牌 */}
        {headerStyle.BrandEnable && (
          <BrandNav
            brand={brand}
            headerStyle={headerStyle}
            isActiveBrand={isBrandActive}
            onActivate={() => {
              setActiveNavByClick('Brand')
              setActiveCustomMenuId(null)
            }}
          />
        )}
        {cusomNav && (
          <CustomPictureNav
            cusomNav={cusomNav}
            headerStyle={headerStyle}
            activeCustomMenuId={activeCustomMenuId}
            onActivate={(parentMenuId) => {
              setActiveCustomMenuId(parentMenuId)
              setActiveNavByClick('Custom')
            }}
          />
        )}
      </>
    )
  }

  return (
    <>
      {/* 商品 */}
      {headerStyle?.GoodsCategoryEnable && (
        <li
          className="navigation__item"
          onMouseLeave={handleMouseLeave}
          onMouseEnter={() => setMenuVisible(true)}
          style={{
            position: 'relative',
          }}
        >
          <Link
            href="/product-list"
            className={`navigation__link`}
            style={{
              color: isProductActive ? HeaderFontFocusColor : HeaderFontColor,
            }}
            onClick={(e) => {
              e.stopPropagation()
              setActiveNavByClick('Product')
              setActiveCustomMenuId(null)
            }}
          >
            商品
          </Link>

          {menuVisible && (
            <div className={styles.menuContainer}>
              {menuLayers.map((items, levelIndex) => (
                <ul key={levelIndex} className={styles.menuList}>
                  {items.map((cat) => {
                    const hasChildren = getChildren(cat.CategoryID).length > 0
                    return (
                      <li
                        key={cat.CategoryID}
                        className={`${styles.menuItem}`}
                        onMouseEnter={() => handleHover(levelIndex, cat)}
                      >
                        <span className={styles.menuLink}>
                          {hasChildren ? (
                            // 🟢 有子層 → 不能點，只是 hover 展開
                            <Link
                              href={`/product-list?categoryid=${cat.CategoryID}`}
                              className={styles.menuLink}
                              onClick={(e) => {
                                e.stopPropagation()
                                setMenuVisible(false)
                                setActiveNavByClick('Product')
                                setActiveCustomMenuId(null)
                              }}
                            >
                              {cat.CategoryName}
                              <span className={styles.chevron}>›</span>
                            </Link>
                          ) : (
                            // 🔵 最後一層 → 可以點擊跳轉
                            <Link
                              href={`/product-list?categoryid=${cat.CategoryID}`}
                              className={styles.menuLink}
                              onClick={(e) => {
                                e.stopPropagation() // 避免觸發 hover 展開
                                setMenuVisible(false) // ✅ 點擊後關閉選單（如果你有這需求）
                                setActiveNavByClick('Product')
                                setActiveCustomMenuId(null)
                              }}
                            >
                              {cat.CategoryName}
                            </Link>
                          )}
                        </span>
                      </li>
                    )
                  })}
                </ul>
              ))}
            </div>
          )}
        </li>
      )}

      {/* 品牌 */}
      {headerStyle.BrandEnable && (
        <BrandNav
          brand={brand}
          headerStyle={headerStyle}
          isActiveBrand={isBrandActive}
          onActivate={() => {
            setActiveNavByClick('Brand')
            setActiveCustomMenuId(null)
          }}
        />
      )}

      {/* 自訂導覽（經典系列 等） */}
      {cusomNav && (
        <CustomNav
          cusomNav={cusomNav}
          headerStyle={headerStyle}
          activeCustomMenuId={activeCustomMenuId}
          onActivate={(parentMenuId) => {
            setActiveCustomMenuId(parentMenuId)
            setActiveNavByClick('Custom')
          }}
        />
      )}
    </>
  )
}
